export const defaultFormatter = (value: number) => String(value)
export const defaultLabelFormatter = (value: string | number) => value
